module.exports = __webpack_public_path__ + "images/insights-board-category-16da5aeb.svg";